import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { GlobalMessageService, GlobalMessageType, RoutingService, TranslatePipe } from '@spartacus/core';
import { KnBrCommonService } from '../services/kn-br-common.service';
import { UntypedFormBuilder, UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { CustomerData } from '../models/customer.model';
import { KnBrCustomerContextService } from '../store/kn-br-customer-context/kn-br-customer-context.service';

@Component({
    selector: 'knbr-kn-br-profile',
    templateUrl: './kn-br-profile.component.html',
    styleUrls: ['./kn-br-profile.component.scss'],
    imports: [ReactiveFormsModule, TranslatePipe]
})
export class KnBrProfileComponent implements OnInit {
  profileDetails;
  selectedCustomer: CustomerData = null;
  notificationListData: [{}];
  subscription = new Subscription();
  profileDetailsForm: UntypedFormGroup;
  profileData$: BehaviorSubject<any> = new BehaviorSubject(null);
  customerContextData$: Observable<CustomerData> = this.knBrCustomerContextService.get$;

  constructor(
    protected fb: UntypedFormBuilder,
    protected cdr: ChangeDetectorRef,
    protected routingService: RoutingService,
    public knBrCommonService: KnBrCommonService,
    protected globalMessageService: GlobalMessageService,
    protected knBrCustomerContextService: KnBrCustomerContextService
  ) {
    this.knBrCommonService.getProfileDetails();
  }

  ngOnInit(): void {
    this.subscription.add(
      this.knBrCommonService.profileData$.subscribe(res => {
        if (res) {
          this.profileDetails = res;
          this.notificationListData = res.notificationListData;
          this.initForm();
          this.cdr.detectChanges();
        }
      })
    )
    this.customerContextData$.subscribe((value) => {
      if (value) {
        this.selectedCustomer = value;
      }
    });
  }

  initForm() {
    this.profileDetailsForm = this.fb.group({
      firstName: [{value: this.profileDetails?.firstName, disabled: true}],
      lastName: [{value: this.profileDetails?.lastName, disabled: true}],
      preferredName: [{value: this.profileDetails?.preferredName, disabled: true}],
      businessEmail: [{value: this.profileDetails?.emailId, disabled: true}],
      businessPhone: [{value: this.checkForCountryCode(this.profileDetails?.businessPhone), disabled: true}],
      extension: [{value: this.profileDetails?.extn, disabled: true}],
      businessCell: [{value: this.checkForCountryCode(this.profileDetails?.businessMobile), disabled: true}],
      alternateMobileNumber: [{value: this.checkForCountryCode(this.profileDetails?.alternateMobile), disabled: true}],
      hireDate: [{value: '', disabled: true}],
      // terminationDate: this.profileDetails?.terminationDate,
      // employeeId: this.profileDetails?.employeeID,
      // employeeStatus: this.profileDetails?.employeeStatus,
      // jobTitle: this.profileDetails?.jobTitle,
      // businessUser: this.profileDetails?.businessUser,
      // role: this.profileDetails?.role,
      // subRole: this.profileDetails?.subRole,
      // internal: this.profileDetails?.internal,
      // external: this.profileDetails?.external,
      // managerEmpId: this.profileDetails?.managerEmployeeID,
      // managerFname: this.profileDetails?.managerFirstName,
      // managerLname: this.profileDetails?.managerLastName,
      // managerPreferredName: this.profileDetails?.manager,
      // departmentId: this.profileDetails?.deptID,
      // departmentDescription: this.profileDetails?.deptDescription,
      // costCenterId: this.profileDetails?.costCenterID,
      // costCenterDescription: this.profileDetails?.costCenterDescription,
      // divisionShortName: this.profileDetails?.divisionShortName,
      // divisionFullName: this.profileDetails?.divisionFullName,
      // businessUnit: this.profileDetails?.sbuShort,
      // businessUnitName: this.profileDetails?.sbuFull,
      // workLocation: this.profileDetails?.workLoc,
      // workLocationDesc: this.profileDetails?.workLocDesc
    });
  }

  select(mode, val) {
    this.notificationListData.push({
      notificationMode : mode,
      notificationType : "Shipping",
      notificationValue : val
    })
  };

  goBack() {
    this.routingService.go({ cxRoute: 'invoiceList' }, { state: { displayPersistedValues: true }});
  }

  checkForCountryCode(phoneNumber) {
    if(phoneNumber?.includes('#')) {
      let splitPhoneByhash = phoneNumber.split('#');
      phoneNumber = splitPhoneByhash[0] + "  " + splitPhoneByhash[1];
    }
    return phoneNumber;
  }

  goTo() {
    if (this.selectedCustomer === null) {
      this.globalMessageService.add({ key: 'customer.context.required' }, GlobalMessageType.MSG_TYPE_INFO);
      this.routingService.goByUrl('/');
    } else {
      this.routingService.go('/contact-us', { state: { fromProfilePage: true }});
    }
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.knBrCommonService.profileData$.next(null)
    }
  }
}
